// Eircode → delivery zone mapping (by routing key, the first 3 chars).
// In production this is a polygon/radius calc off the store point; here it's a
// lookup keyed to the Irish midlands around the Kilcormac store.

// Relative preferences, not fixed dates — the shop confirms the exact time when it
// follows up on the order request. Keeps slots from going stale/past-dated.
export const COLLECT_SLOTS = [
  "This Saturday · morning",
  "This Saturday · afternoon",
  "This Sunday · late morning",
  "A weekday evening",
  "Next weekend",
];

const ZONES = {
  // Offaly / Kilcormac / Birr / Tullamore
  R35: { name: "Tullamore & east Offaly", fee: 5, eta: "1–2 days" },
  R42: { name: "Kilcormac, Birr & west Offaly", fee: 5, eta: "1–2 days" },
  // Westmeath
  N91: { name: "Athlone & Westmeath", fee: 6, eta: "1–2 days" },
  N37: { name: "Mullingar", fee: 6, eta: "1–2 days" },
  // Laois
  R32: { name: "Portlaoise & Laois", fee: 6, eta: "2–3 days" },
};

// Wider national next-day-ish band for any other valid routing key.
const NATIONAL = { name: "Rest of Ireland", fee: 9, eta: "2–4 days" };

const EIRCODE_RE = /^[AC-FHKNPRTV-Y]\d{2}\s?[0-9AC-FHKNPRTV-Y]{4}$/i;

export function lookupZone(raw) {
  const eircode = (raw || "").trim().toUpperCase().replace(/\s+/g, "");
  if (!EIRCODE_RE.test(eircode)) {
    return { status: "invalid" };
  }
  const key = eircode.slice(0, 3);
  const zone = ZONES[key];
  if (zone) return { status: "ok", zone };
  // Valid Eircode but outside the named local zones — still deliverable nationally.
  return { status: "ok", zone: NATIONAL };
}
